import React, { useState, useEffect } from 'react'
import { examService } from '../../_services/exam.service'
import examStatuses from '../../_constants/examStatuses'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import { RiCloseLine } from 'react-icons/ri'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

export default function MemberExamDetails(props) {
  const [loading, setLoading] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    setShowDialog(props.show)

    getData(props.examId)
  }, [props.show, props.examId])

  const getData = id => {
    setLoading(true)
    examService
      .getMemberExamQuestions(id)
      .then(res => {
        // console.log(res.data);
        setData(res.data)
        setLoading(false)
      })
      .catch(err => {
        // console.log(err)
        setLoading(false)
      })
  }

  const handleCloseDialog = () => {
    setShowDialog(false)

    props.onClose()
  }

  return (
    <React.Fragment>
      <Dialog
        maxWidth="lg"
        fullWidth
        className="message-dialog"
        open={showDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleCloseDialog()}>
        <DialogContent>
          <a className="dialog-close-btn" onClick={() => handleCloseDialog()}>
            <RiCloseLine />
          </a>

          {data &&
            data.map((item, index) => (
              <div
                className="row"
                key={'q-' + item.question.id + '-index-' + index}>
                <div className="col-md-10 col-md-offset-1">
                  <fieldset className="fieldset">
                    <legend>{'سوال ' + (index + 1)}</legend>
                    <h4>{item.question.name}</h4>
                    <RadioGroup
                      row
                      aria-label="position"
                      name={item.question.id}
                      onChange={e => {}}>
                      {item.question.answers &&
                        item.question.answers.map((answer, aIndex) => (
                          <FormControlLabel
                            key={
                              'q-' +
                              item.question.id +
                              '-a-' +
                              answer.id +
                              'index-' +
                              aIndex
                            }
                            value={answer.id}
                            control={<Radio color="primary" size="medium" />}
                            label={answer.name}
                            labelPlacement="end"
                            className={`radio-btn-label ${
                              answer.isCorrect ? 'is-correct' : ''
                            }`}
                            checked={answer.id === item.selectedAnswerId}
                          />
                        ))}
                    </RadioGroup>
                  </fieldset>
                </div>
              </div>
            ))}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}
